var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapFireProposedBurnArea = function SvgFiremapFireProposedBurnArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "firemap-fire-proposed-burn-area_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2h20v20H2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#firemap-fire-proposed-burn-area_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M-22.09-6.182h71.817v36.364H-22.09zm4.388 1.653h3.192v33.058h-3.192zm3.99 33.058V-4.53h3.192v33.058zm3.99 0h3.192V-4.53h-3.192zm7.182 0h-3.192V-4.53h3.192zm.798 0H1.45V-4.53h-3.192zm7.181 0H2.248V-4.53h3.191zm.798 0H9.43V-4.53H6.237zm7.182 0h-3.192V-4.53h3.192zm.798 0h3.192V-4.53h-3.192zm7.182 0h-3.192V-4.53H21.4zm.798 0h3.192V-4.53h-3.192zm7.182 0h-3.192V-4.53h3.192zm.798 0h3.192V-4.53h-3.192zm7.182 0h-3.192V-4.53h3.192zm.798 0h3.192V-4.53h-3.192zm7.182 0h-3.192V-4.53h3.192zm.797 0h1.995V-4.53h-1.995zM-18.5-4.53h-1.995v33.058h1.995z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M3 3h18v18H3z"
  }))));
};
export default SvgFiremapFireProposedBurnArea;